import _ from 'lodash';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import MhxBolsContainer from '../../containers/billing/MhxBols';
import AuthUserContainer from '../../containers/AuthUser';

import { getSharedStyles } from '../../themes';
import EnhancedTable from '../../components/table/EnhancedTable';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';
// import OpenLink from '@material-ui/icons/OpenInNew';

import GreenChecked from '../../images/icons/greenChecked.svg';
import YellowWarning from '../../images/icons/yellowWarning.svg';
import ErrorIcon from '../../images/icons/error.svg';

import ResourcePopup from '../../components/Dialogs/ResourcePopup';
import BolLinkedStatus from '../../components/billing/BolLinkedStatus';
import invoiceIcon from '../../images/invoicePdf.svg';
import { orange } from '@material-ui/core/colors';

const styles = (theme) => ({
	...getSharedStyles(theme),
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	docContainer: {
		position: 'absolute',
	},
	addButton: {
		verticalAlign: 'middle',
		textDecoration: 'none',
		marginBottom: 10,
		borderRadius: 100,
	},
	greenCheckedIconSmall: {
		backgroundImage: `url('${GreenChecked}')`,
		display: 'inline-block',
		width: 16,
		height: 16,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	warningIconSmall: {
		backgroundImage: `url('${YellowWarning}')`,
		display: 'inline-block',
		width: 22,
		height: 22,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	errorIconSmall: {
		backgroundImage: `url('${ErrorIcon}')`,
		display: 'inline-block',
		width: 18,
		height: 18,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight: 2,
	},
	invoiceIcon: {
		display: 'inline-block',
		width: 40,
		height: 48,
		backgroundImage: `url('${invoiceIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		position: 'relative',
		flexShrink: 0,
		cursor: 'pointer',
	},
});

const columns = [
	{
		sortId: 'mhxBolId',
		displayId: 'mhxBolId',
		label: 'ID',
	},

	{
		sortId: 'bolNumber',
		displayId: 'bolNumber',
		label: 'BOL #',
	},
	{
		sortId: 'railcarDisplay',
		displayId: 'railcarDisplay',
		label: 'Railcar #s',
	},
	{
		sortId: 'loadingNumber',
		displayId: 'loadingNumber',
		label: 'Loading #',
	},
	{
		sortId: 'pickupDateTime',
		displayId: 'pickupDateTimeFormatted',
		label: 'Pickup Date',
	},
	{
		sortId: 'finishedDateTime',
		displayId: 'finishedDateTimeFormatted',
		label: `Finished Date`,
	},
	{
		sortId: 'netGallons',
		displayId: 'netGallons',
		label: 'Net Gallons',
	},
	{
		sortId: 'grossGallons',
		displayId: 'grossGallons',
		label: 'Gross Gallons',
	},
	{
		sortId: 'bolPdf',
		displayId: 'bolPdf',
		label: 'BOL PDF',
	},
	{
		sortId: 'linkedStationDeliveryId',
		displayId: 'linkedStationDeliveryDisplay',
		label: 'Linked Delivery',
	},
	{
		sortId: 'linkedStatus',
		displayId: 'linkedStatusDisplay',
		label: 'Linked Status',
	},
];

class MhxBols extends Component {
	constructor(props) {
		super(props);

		const startingTab = _.get(this.props, ['match', 'params', 'startingTab'], 'current');
		const startingTabIndex = { current: 0, issued: 1, invalid: 2 }[startingTab] || 0;

		this.state = {
			tabIndex: startingTabIndex,
			order: 'desc',
			orderBy: 'mhxBolId',
			search: '',
			filterMap: {},
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
			isInvalidOpen: false,
		};
	}

	componentDidMount() {
		const { mhxBols, mhxBolSearch } = this.props;

		if (!mhxBols) {
			mhxBolSearch({ afterDateTime: moment().subtract(2, 'months').format('YYYY-MM-DD') });
		} else {
			this.formatMhxBols();
		}
	}

	componentDidUpdate(prevProps) {
		const { mhxBols } = this.props;
		if (prevProps.mhxBols !== mhxBols) {
			this.formatMhxBols();
		}
	}

	formatMhxBols = () => {
		const { mhxBols, stationMap } = this.props;

		const rows = [];
		mhxBols.forEach((mhxBol) => {
			const {
				mhxBolId,
				dateCreated,
				pickupDateTime,
				finishedDateTime,
				// bolNumber,
				bolPdfResourceId,
				railcarNumbers,
				// loadingNumber,
				// customerId,
				// product,
				// netGallons,
				// grossGallons,
			} = mhxBol;

			mhxBol.key = mhxBolId;
			mhxBol.pickupDateTimeFormatted = pickupDateTime
				? moment(pickupDateTime).format('M/D/YY h:mm a')
				: '-';
			mhxBol.finishedDateTimeFormatted = finishedDateTime
				? moment(finishedDateTime).format('M/D/YY h:mm a')
				: '-';
			const isOverTwoDays = moment().diff(moment(dateCreated), 'days') > 2;

			mhxBol.bolPdf = bolPdfResourceId ? (
				<>
					<Button
						onClick={() => {
							this.handlePdfClick(bolPdfResourceId);
						}}
					>
						View
					</Button>
				</>
			) : isOverTwoDays ? (
				<div style={{ color: 'red' }}>Missing!</div>
			) : (
				'Pending...'
			);

			mhxBol.railcarDisplay = railcarNumbers.join(', ');

			mhxBol.linkedStatusDisplay = (
				<BolLinkedStatus
					linkedStatus={mhxBol.linkedStatus}
					message={mhxBol.linkedErrorMessage}
					statusColorOverrides={{ deliveryLinked: orange[500] }}
				/>
			);

			if (mhxBol.linkedStationDeliveryId) {
				const station = stationMap[mhxBol.linkedStationId] || { number: 'Missing' };
				mhxBol.linkedStationDeliveryDisplay = (
					<div>
						<div style={{ whiteSpace: 'nowrap' }}>
							Station Delivery #
							<a
								href={`/logistics/stationDelivery/update/${mhxBol.linkedStationDeliveryId}`}
								style={{ textDecoration: 'none', paddingTop: 5, paddingLeft: 5 }}
								target="_blank"
								rel="noreferrer noopener"
							>
								<strong>{mhxBol.linkedStationDeliveryId}</strong>
							</a>
						</div>
						<div>
							Station: {station.number} / Tank: {mhxBol.linkedTankNumber}
						</div>
					</div>
				);
			}

			rows.push(mhxBol);
		});
		this.setState({ rows });
	};

	handleView = (mhxBolId) => {
		this.props.history.push(`/billing/mhxBol/view/${mhxBolId}`);
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handlePdfClick = (resourceId) => {
		this.setState({
			resourceIdsPoppedUp: [resourceId],
			isResourcePopupOpen: true,
		});
	};

	handleCloseResourcePopup = () => {
		this.setState({
			isResourcePopupOpen: false,
			resourceIdsPoppedUp: [],
		});
	};

	render() {
		const { classes, resourceMap } = this.props;
		const { rows, order, orderBy } = this.state;

		if (!rows) {
			return <div>Loading the MHX BOLs...</div>;
		}

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={8}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>MHX BOLs</span>
							</Typography>
						</Grid>
					</Grid>

					<Paper className={classes.paper}>
						<EnhancedTable
							columns={columns}
							rows={rows}
							defaultOrder={order}
							defaultOrderBy={orderBy}
						/>

						<ResourcePopup
							open={this.state.isResourcePopupOpen}
							onClose={this.handleCloseResourcePopup}
							resourceIds={this.state.resourceIdsPoppedUp}
							resourceMap={resourceMap}
						/>
					</Paper>
				</Grid>
			</Grid>
		);
	}
	closeInvalidDialog = () => {
		this.setState({ isInvalidOpen: false });
	};
}

MhxBols.propTypes = {
	classes: PropTypes.object.isRequired,
	mhxBolSearch: PropTypes.func.isRequired,
	mhxBols: PropTypes.array,

	showErrors: PropTypes.func.isRequired,
	resourceMap: PropTypes.object,
	stationMap: PropTypes.object,

	history: PropTypes.object,
	theme: PropTypes.object.isRequired,
	authUser: PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	MhxBolsContainer,
])(MhxBols);
